var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 175,
    viewBox: "0 0 174 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 112L87 88M111 64L87 88M87 88L63 64L111 112",
    stroke: "url(#paint0_linear_32989_57967)",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5833 167.083C130.536 167.083 166.167 131.452 166.167 87.4998C166.167 43.5472 130.536 7.9165 86.5833 7.9165C42.6307 7.9165 7 43.5472 7 87.4998C7 131.452 42.6307 167.083 86.5833 167.083Z",
    stroke: "url(#paint1_linear_32989_57967)",
    strokeWidth: 14
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32989_57967",
    x1: 63,
    y1: 64.0252,
    x2: 110.95,
    y2: 111.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE1180"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32989_57967",
    x1: 7,
    y1: 8,
    x2: 166,
    y2: 167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE1180"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.ebb0f62a.svg";
export { ForwardRef as ReactComponent };